import React, { useState, useRef, useEffect, useContext } from 'react'
import { ButtonHeading, ConsigneeDetailsTab, VehicleDetailsTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import LoadingBar from 'react-top-loading-bar';
import FuelStatement from '../FuelStatement';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import VehicleDocuments from '../VehicleDocuments';
import { AddFuelModal, AddFuelOwn } from 'modals';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { VehicleGps } from '../VehicleGps';
import { VehicleGpsSetting } from '../VehicleGpsSetting';
import { getVehicleDetails } from '_services/accountsServices/vehicleServices';
import { UserContext } from 'context';
import StorageService from 'utils/StorageServices';
import { API, AppConfig } from 'lib';
import toast from 'react-hot-toast';

const VehicleDetails = () => {
    useDocumentTitle("Truck Details | T360");

    let isToken = localStorage.getItem("token");
    let { id } = useParams();
    const { masterData, settingChild, setMasterDetailsList } = useContext(UserContext)
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const vehicleNo = queryParams.get('vehicle_no');
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    const loadingBarRef = useRef(null)
    const [getData, setGetData] = useState(null)
    const [isOpenFuel, setIsOpenFuel] = useState(false);
    const [addFuel, setAddFuel] = useState(0);
    const [singleVehicleData, setSingleVehicleData] = useState({});
    const [loading, setLoading] = useState(false);

    const settingChildGPS = settingChild?.find((i) => i?.label === "GPS Integration");

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: settingChildGPS?.available === 1 ? (singleVehicleData?.vehicle_ownership === 2 ? constant.vehicle_DetailsTabs1 : constant.vehicle_DetailsTabs) : (singleVehicleData?.vehicle_ownership === 2 ? constant.vehicle_DetailsTabs1Permission : constant.vehicleDetailsTabsPermission),
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab,
    }

    const handleDataFetch = (data) => {
        setGetData(data)
        setAddFuel("")
    }

    const toggleOffcanvas = () => {
        setIsOpenFuel(!isOpenFuel);

    };

    const callbackTotal = () => {
        setAddFuel((prev) => Number(prev) + 1);
    }

    let fuelProps = {
        isOpen: isOpenFuel,
        closeModal: (e) => setIsOpenFuel(false),
        headerPart: true,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Fuel",
        submitTitle: "Add Fuel",
        getData: getData,
        callBackFreight: callbackTotal,

    };

    const getSingleVehicleData = async () => {
        setLoading(true);
        try {
            let object = {
                vehicle_id: id,
            }
            const res = await getVehicleDetails(object);
            if (res?.responseCode == 200) {
                setSingleVehicleData(res?.data?.vehicle);
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (id) {
            getSingleVehicleData()
        }
    }, [id])

    const documentExportHandler = async () => {
        setLoading(true)
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                vehicle_no: vehicleNo
            }
            const response = await fetch(`${AppConfig.api_baseurl}${API.EXPORT_VEHICLE_DOCUMENT_SINGLE}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({}));
                if (errorBody?.responseMessage) {
                    toast.error(errorBody?.responseMessage);
                }
                throw new Error(`Server Error (${errorBody?.responseMessage})`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `vehicle_${vehicleNo}_document.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        setActiveTab(tabFromQuery)
    }, [tabFromQuery])

    return (
        <div className=''>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={vehicleNo ? vehicleNo : 'Loading...'}
                buttonTitle={(tabFromQuery === 3 && getData?.vehicle_ownership != 2) && "Add Fuel"}
                onClick={toggleOffcanvas}
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/vehicle'); setMasterDetailsList({}) }} // navigate(-1)
                addDocumentButton={activeTab === 1 ? true : false}
                singleDocumentExport={activeTab === 1 ? true : false}
                singleDocumentExportHandler={(e) => documentExportHandler(e)}
                exportLoading={loading}
                vehicleTypeName={true}
                loading={loading}
                vehicleTypeNameData={{
                    vehicleType: masterData?.vehicle_ownership[singleVehicleData?.vehicle_ownership],
                    vehicle_no: singleVehicleData?.vehicle_no,
                    name: `${singleVehicleData?.lorry_type_id?.lorry_type} > ${singleVehicleData?.vehicle_type_id?.name}`
                }}
            />

            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab === 1 &&
                    <VehicleDocuments
                        onDataFetch={handleDataFetch}
                        loadingBarRef={loadingBarRef}
                        vehicleNo={vehicleNo}
                    />
                }

                {activeTab === 2 && (
                    <VehicleDetailsTab onDataFetch={handleDataFetch} loadingBarRef={loadingBarRef} addFuel={addFuel} />
                )}

                {activeTab === 3 && <FuelStatement onDataFetch={handleDataFetch} addFuel={addFuel} />}
                {activeTab === 4 && <VehicleGps />}
                {activeTab === 5 && <VehicleGpsSetting callApiVehicleDetails={(e) => getSingleVehicleData(e)} singleVehicleData={singleVehicleData} />}

                {isOpenFuel && <AddFuelOwn {...fuelProps} />}

            </div>

        </div>
    )
}

export default VehicleDetails;